import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_LEGAL_ISSS_REQUEST = "GET_LEGAL_ISSS_REQUEST";
export const GET_LEGAL_ISSS_SUCCESS = "GET_LEGAL_ISSS_SUCCESS";
export const GET_LEGAL_ISSS_ERROR = "GET_LEGAL_ISSS_ERROR";

//* ACTIONS ------------------------------------------------
export const getLegalISSSRequest = (payload = {}, callback) => ({
  type: GET_LEGAL_ISSS_REQUEST,
  payload,
  callback,
});

export const getLegalISSSSuccess = (data) => ({
  type: GET_LEGAL_ISSS_SUCCESS,
  payload: data,
});

export const getLegalISSSError = (error) => ({
  type: GET_LEGAL_ISSS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getLegalISSSServiceRequest = async ({ payrollId, periodId, ...params }) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/payrolls/${payrollId}/periods/${periodId}/isss`, options);
};
